// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_ib-0";
export var animationContainer = "_ib-1";
export var itemPrice = "_ib-a";
export var itemizedContent = "_ib-9";
export var itemizedHeader = "_ib-7";
export var itemizedRow = "_ib-8";
export var itemizedSection = "_ib-6";
export var modalContent = "_ib-2";
export var orderName = "_ib-3";
export var refundOption = "_ib-4";
export var refundOptionsContainer = "_ib-5";
export var shippingLabel = "_ib-b";
export var totalRow = "_ib-c";